<template>
  <div class="bill" >
    <el-divider content-position="left">开票申请</el-divider>
    <el-form :model="applyData" ref="applyData" label-width="100px" size="mini">
      <el-row>
        <el-col :span="16">
          <el-select v-model="applyData.invoice_mode" placeholder="请选择开具发票的方式" size="mini">
            <el-option label="普通开具" :value="1"></el-option>
            <el-option label="差额征收" :value="2"></el-option>
          </el-select>
          <el-select v-model="applyData.is_tax_inclusive" placeholder="请选择发票是否含税" size="mini">
            <el-option label="含税" :value="1"></el-option>
            <el-option label="不含税" :value="2"></el-option>
          </el-select>
          <el-select v-model="applyData.invoice_type" placeholder="请选择开具发票的票种" size="mini">
            <el-option label="增值税普通发票" :value="1"></el-option>
            <el-option label="增值税专用发票" :value="2"></el-option>
            <el-option label="增值税电子普通发票" :value="3"></el-option>
            <el-option label="增值税电子专用发票" :value="4"></el-option>
          </el-select>
          <el-select filterable collapse-tags v-model="applyData.exec_id" placeholder="请选择开票执行人" size="mini" clearable>
            <el-option
              v-for="(item, index) in users"
              :key="index"
              :label="item.username"
              :value="item.id">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="8" style="text-align: right">
          <span>商户（销方名称）：</span>
          <el-select v-model="applyData.company_id"
            filterable remote reserve-keyword
            placeholder="请输入公司名称筛选公司"
            size="mini" clearable
            :remote-method="searchRemoteCompanyMethod"
            :loading="searchLoading"
            @change="handleSearchCompanyChange">
            <el-option v-for="searchCompany in searchCompanies"
            :key="searchCompany.id"
            :label="searchCompany.company_name"
            :value="searchCompany.id">
            </el-option>
          </el-select>
        </el-col>
      </el-row>
    </el-form>
    <el-row class="invoiceBox">
      <el-col :span="24">
        <el-row>
          <el-col :span="6">
            <el-col :span="6" style="line-height: 30px;">税盘编号：</el-col>
            <el-col :span="18" class="cInputB">
              <el-input v-model="applyData.tax_plate_num" size="mini"></el-input>
            </el-col>
          </el-col>
          <el-col :offset="1" :span="6">
            <el-col :span="6" style="line-height: 30px;">档案位置：</el-col>
            <el-col :span="18" class="cInputB">
              <el-input v-model="applyData.file_location" size="mini"></el-input>
            </el-col>
          </el-col>
        </el-row>
        <el-row class="mt-10 cBorder_top">
          <el-row>
            <el-col :span="1" class="cBorder_1" style="height:  187px; border-left: 2px solid #9e5309">
              购
              <br>
              方
              <br>
              信
              <br>
              息
            </el-col>
            <el-col :span="13" class="cBorder_2" style="text-align: right">
              <el-row type="flex">
                <el-col :span="6">
                  <span class="errr">*</span>
                    名&emsp;&emsp;&emsp;&nbsp;&nbsp;称：
                </el-col>
                <el-col :span="18" class="cInputB">
                  <el-input v-model="applyData.buyer_name" size="mini" @change="getBuyerHistory" placeholder="请输入购方公司名称"></el-input>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="6">
                    发&nbsp;&nbsp;票&nbsp;&nbsp;税&nbsp;&nbsp;号：
                </el-col>
                <el-col :span="18" class="cInputB">
                  <el-input v-model="applyData.buyer_tax_num" size="mini" placeholder=""></el-input>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="6">
                    地&emsp;&emsp;&emsp;&nbsp;&nbsp;址：
                </el-col>
                <el-col :span="18" class="cInputB">
                  <el-input v-model="applyData.buyer_address" size="mini"></el-input>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="6">
                    电&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;话：
                </el-col>
                <el-col :span="18" class="cInputB">
                  <el-input v-model="applyData.buyer_phone" size="mini"></el-input>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="6">
                    开&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;户&nbsp;&nbsp;&nbsp;&nbsp;行：
                </el-col>
                <el-col :span="18" class="cInputB">
                  <el-input v-model="applyData.buyer_bank" size="mini"></el-input>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="6">
                    银&nbsp;&nbsp;行&nbsp;&nbsp;账&nbsp;&nbsp;号：
                </el-col>
                <el-col :span="18" class="cInputB">
                  <el-input v-model="applyData.buyer_bank_num" size="mini"></el-input>
                </el-col>
              </el-row>
            </el-col>
            <el-col :span="1" class="cBorder_1" style="height:  187px;">
              发
              <br>
              票
              <br>
              明
              <br>
              细
            </el-col>
            <el-col :span="9" class="cBorder_2" style="height: 187px; padding: 10px 15px 0 10px">
              <el-col :span="24">
                <el-radio-group v-model="detail_type" size="mini" style="margin-left: 10px; margin-bottom: 15px;">
                  <el-radio border label="文本明细">文本明细</el-radio>
                  <el-radio border label="图片文件">图片文件</el-radio>
                </el-radio-group>
              </el-col>
              <el-col :span="24" v-if="detail_type === '文本明细'">
                <el-input type="textarea" show-word-limit :rows="4" maxlength="500" v-model="applyData.invoice_detail"></el-input>
              </el-col>
              <el-col :span="24" v-else>
                <el-form :model="applyData" ref="applyData" label-width="100px" size="mini">
                  <el-card shadow="hover">
                    <el-upload
                      multiple
                      ref="upload"
                      action="#"
                      :limit="5"
                      :on-preview="handleLicensePreview"
                      :on-change="handleLicenseChange"
                      :on-remove="handleLicenseRemove"
                      :file-list="licenseList"
                      accept=".jpg, .jpeg, .png, .gif, .pdf, .doc, .docx, .xls, .xlsx, .ppt, .pptx"
                      list-type="file"
                      :auto-upload="false">
                      <el-link slot="trigger" type="primary">上传截图或文件(最多可上传5个)</el-link>
                    </el-upload>
                  </el-card>
                </el-form>
              </el-col>
            </el-col>
          </el-row>
        </el-row>
        <el-row style="padding-right: 16px; border-right: 2px solid rgb(158, 83, 9); row-gap: 0px;">
          <el-col :span="1" class="cBorder_3_left">&nbsp;</el-col>
          <el-col :span="5" class="cBorder_7">
            <span class="errr">*</span>
            货物或应税劳务、服务名称
          </el-col>
          <!-- <el-col :span="3" class="cBorder_7">
            规格型号
          </el-col>
          <el-col :span="2" class="cBorder_7">
            单位
          </el-col>
          <el-col :span="3" class="cBorder_7">
            数量
          </el-col>
          <el-col :span="3" class="cBorder_7">
            单价（含税）
          </el-col> -->
          <el-col :span="3" class="cBorder_7">
            开票金额
          </el-col>
          <!-- <el-col :span="2" class="cBorder_7">
            税率
          </el-col>
          <el-col :span="2" class="cBorder_7">
            税额
          </el-col> -->
        </el-row>
        <el-row type="flex" style="border-right: 2px solid #9e5309; overflow-y: scroll">
          <el-col :span="1" class="cBorder_3_left">&nbsp;</el-col>
          <el-col :span="5" class="cBorder_7">
            <el-input placeholder="请输入内容" v-model="applyData.invoice_cate" class="input-with-select" size="mini"></el-input>
          </el-col>
          <!-- <el-col :span="3" class="cBorder_7">
            <el-input v-model="cargo.type" size="mini"></el-input>
          </el-col>
          <el-col :span="2" class="cBorder_7">
            <el-input v-model="cargo.unit" size="mini"></el-input>
          </el-col>
          <el-col :span="3" class="cBorder_7">
            <el-input type="number" v-model="cargo.amount" size="mini"></el-input>
          </el-col>
          <el-col :span="3" class="cBorder_7">
            <el-input type="number" v-model="cargo.price" size="mini"></el-input>
          </el-col> -->
          <el-col :span="3" class="cBorder_7">
            <el-input type="number" v-model="applyData.invoice_amount" size="mini"></el-input>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="1" class="cBorder_3 cBorder_3_left">1</el-col>
          <el-col :span="2" class="cBorder_7"></el-col>
        </el-row>
        <el-row>
          <el-col :span="7" class="cBorder_5">价税合计(大写)</el-col>
          <el-col :span="6" class="cBorder_8"></el-col>
          <el-col :span="11" class="cBorder_6"></el-col>
        </el-row>
        <el-row class="cBorder_top">
          <el-row>
            <el-col :span="1" class="cBorder_1" style="border-left: 2px solid #9e5309; height: 155.39px; padding-top: .4rem">
              销
              <br>
              方
              <br>
              信
              <br>
              息
            </el-col>
            <el-col :span="13" class="cBorder_2" style="text-align: right">
              <el-row type="flex" class="pdtb5">
                <el-col :span="6">
                  <span class="errr">*</span>
                    名&emsp;&emsp;&emsp;&nbsp;&nbsp;称：
                </el-col>
                <el-col :span="17" class="text-left">
                  {{ applyData.company_name }}
                </el-col>
              </el-row>
              <el-row class="pdtb5">
                <el-col :span="6">
                    纳税人识别号：
                </el-col>
                <el-col :span="17" class="text-left">
                  {{ applyData.invoice_tax }}
                </el-col>
              </el-row>
              <el-row class="pdtb5">
                <el-col :span="6">
                    地址、&nbsp;&nbsp;&nbsp;电话：
                </el-col>
                <el-col :span="17" class="text-left hide-style">
                  {{ applyData.operate_address }}  {{ applyData.legaler_contact }}
                </el-col>
              </el-row>
              <el-row class="pdtb5">
                <el-col :span="6">
                    开户行及账号：
                </el-col>
                <el-col :span="17">
                  <el-select v-model="applyData.bank_id"
                    style="width: 100%"
                    size="mini">
                    <el-option v-for="bank in banks"
                    :key="bank.id"
                    :label="bank.bank + ' ' + bank.accnumber"
                    :value="bank.id">
                    </el-option>
                  </el-select>
                </el-col>
              </el-row>
            </el-col>
            <el-col :span="1" class="cBorder_1" style="height: 155.39px; padding-top: .4rem">
              申
              <br>
              请
              <br>
              备
              <br>
              注
            </el-col>
            <el-col :span="9" class="cBorder_2" style="height: 155.39px; padding: 15px">
              <el-input type="textarea" show-word-limit :rows="5" maxlength="200" v-model="applyData.invoice_remark"></el-input>
            </el-col>
          </el-row>
          <el-row style="padding: 20px; row-gap: 0px">
            <el-col :span="8" class="bill-bottom">
              <span>
                收款人：
                <el-input class="cInputB" v-model="applyData.invoice_payee" size="mini" style="width: 70%" readonly></el-input>
              </span>
            </el-col>
            <el-col :span="8" class="bill-bottom">
              <span>
                复核人：
                <el-input class="cInputB" v-model="applyData.invoice_reviewer" size="mini" style="width: 70%" readonly></el-input>
              </span>
            </el-col>
            <el-col :span="8" class="bill-bottom">
              <span>
                开票人：
                <el-input class="cInputB" v-model="applyData.invoice_drawer" size="mini" style="width: 70%" readonly></el-input>
              </span>
            </el-col>
          </el-row>
          <el-row style="margin-top: 20px; text-align: center">
            <el-col :span="24">
              <el-button plain size="mini" @click="goBackPrev">返回</el-button>
              <!-- <el-button plain size="mini">保存草稿</el-button> -->
              <el-button type="primary" size="mini" @click="handleAddApply('applyData')">提交申请</el-button>
            </el-col>
          </el-row>
        </el-row>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: 'Bill',
  data () {
    return {

      applyData: {
        invoice_mode: 1,
        invoice_type: null,
        is_tax_inclusive: null,
        company_id: null,
        company_name: '',
        invoice_cate: '',
        invoice_amount: null,
        invoice_tax: '',
        operate_address: '',
        legaler_contact: '',
        invoice_payee: '', // 收款人
        invoice_reviewer: '', // 复核人
        invoice_drawer: '', // 开票人
        bank_id: '', // 销方银行信息
        buyer_tax_num: '', // 发票税号
        buyer_address: '', // 地址
        buyer_phone: '', // 电话
        buyer_bank: '', // 开户行
        buyer_bank_num: '', // 银行账号
        invoice_detail: '', // 发票明细
        invoice_remark: '', // 申请备注
        tax_plate_num: '', // 税盘编号
        file_location: '', // 档案位置
        exec_id: null
      },
      formData: null,
      detail_type: '文本明细',
      searchCompanies: [],
      searchLoading: false,
      users: [],
      banks: [],
      licenseList: []
    }
  },
  computed: {
    collapse () {
      return this.$store.state.collapse
    }
  },
  methods: {
    searchRemoteCompanyMethod (query) {
      if (query !== '') {
        this.searchLoading = true
        setTimeout(() => {
          this.searchLoading = false
          this.searchArrItemCompanys(query)
        }, 200)
      } else {
        this.searchCompanies = []
      }
    },
    searchArrItemCompanys (query) {
      this.$axios.get('/api/admin/searchCompany?name=' + query)
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            this.searchCompanies = data.data.companies
          }
        })
    },
    goBackPrev () {
      this.$router.go(-1)
    },
    handleSearchCompanyChange (val) {
      if (!val) {
        this.applyData.exec_id = null
        this.applyData.company_name = ''
        this.applyData.invoice_tax = ''
        this.applyData.operate_address = ''
        this.applyData.legaler_contact = ''
        this.applyData.invoice_payee = ''
        this.applyData.invoice_reviewer = ''
        this.applyData.invoice_drawer = ''
        this.applyData.file_location = ''
        this.applyData.bank_id = ''
        this.banks = []
        return
      }
      this.$axios.get('/api/admin/companies/info/' + val)
        .then((res) => {
          let { data } = res
          if (data.code === 0) {
            this.applyData.company_name = data.data.myCompany.company_name
            this.applyData.invoice_tax = data.data.myCompany.taxNumber
            this.applyData.operate_address = data.data.myCompany.operate_address
            this.applyData.legaler_contact = data.data.myCompany.legaler_contact
            this.applyData.invoice_payee = data.data.myCompany.invoice_payee
            this.applyData.invoice_reviewer = data.data.myCompany.invoice_reviewer
            this.applyData.invoice_drawer = data.data.myCompany.invoice_drawer
            this.applyData.file_location = data.data.file_location
            this.applyData.exec_id = data.data.invoice_id
            this.banks = data.data.myCompany.banks
            if (this.banks.length > 0) {
              this.applyData.bank_id = this.banks[0].id
            } else {
              this.applyData.bank_id = ''
            }
          }
        })
    },
    getInvoicePubData () {
      this.$axios.get('/api/invoice_add/pub_data')
        .then((res) => {
          let { data } = res
          if (data.code === 0) {
            this.users = data.data.users
          }
        })
    },
    getBuyerHistory () {
      if (!this.applyData.buyer_name) {
        // this.applyData.buyer_name = ''
        this.applyData.buyer_tax_num = '' // 发票税号
        this.applyData.buyer_address = '' // 地址
        this.applyData.buyer_phone = '' // 电话
        this.applyData.buyer_bank = '' // 开户行
        this.applyData.buyer_bank_num = '' // 银行账号
        this.applyData.exec_id = '' // 银行账号
        return
      }
      this.$axios.get('/api/get_buyer_history?name=' + this.applyData.buyer_name)
        .then((res) => {
          let { data } = res
          if (data.code === 0) {
            if (!data.data.info) {
              // this.applyData.buyer_name = ''
              this.applyData.buyer_tax_num = '' // 发票税号
              this.applyData.buyer_address = '' // 地址
              this.applyData.buyer_phone = '' // 电话
              this.applyData.buyer_bank = '' // 开户行
              this.applyData.buyer_bank_num = '' // 银行账
              this.applyData.exec_id = '' // 银行账号
              return
            }
            this.applyData.buyer_name = data.data.info.buyer_name
            this.applyData.buyer_tax_num = data.data.info.invoice_tax // 发票税号
            this.applyData.buyer_address = data.data.info.buyer_address // 地址
            this.applyData.buyer_phone = data.data.info.buyer_phone // 电话
            this.applyData.buyer_bank = data.data.info.invoice_bank // 开户行
            this.applyData.buyer_bank_num = data.data.info.invoice_account // 银行账号
            this.applyData.exec_id = data.data.info.exec_id // 银行账号
          }
        })
    },
    handleLicensePreview (file) {},
    handleLicenseChange (file, fileList) {
      this.licenseList = fileList
    },
    handleLicenseRemove (file, fileList) {
      this.licenseList = fileList
      this.formData = null
      this.formData = new FormData()
      this.licenseList.forEach(file => this.formData.append('file[]', file.raw))
      for (let key in this.applyData) {
        this.formData.append(key, this.applyData[key])
      }
    },
    handleAddApply (formName) {
      if (!this.applyData.company_name) {
        this.$message.error('请选择商户（销方名称）')
        return
      }
      if (!this.applyData.invoice_tax || !this.applyData.operate_address || !this.applyData.legaler_contact || !this.applyData.invoice_payee || !this.applyData.invoice_reviewer || !this.applyData.invoice_drawer || this.banks.length <= 0) {
        this.$message.warning('请先在财务登记表中补齐销方信息')
        return
      }
      if (!this.applyData.invoice_mode) {
        this.$message.error('请选择开具发票的方式')
        return
      }
      if (!this.applyData.is_tax_inclusive) {
        this.$message.error('请选择发票是否含税')
        return
      }
      if (!this.applyData.invoice_type) {
        this.$message.error('请选择开具发票的票种')
        return
      }
      if (!this.applyData.exec_id) {
        this.$message.error('请选择开具发票的执行人')
        return
      }
      if (!this.applyData.buyer_name) {
        this.$message.error('请填写购方名称')
        return
      }
      if (!this.applyData.buyer_tax_num) {
        this.$message.error('请填写购方发票税号')
        return
      }
      if (!this.applyData.buyer_address) {
        this.$message.error('请填写购方地址')
        return
      }
      if (!this.applyData.buyer_phone) {
        this.$message.error('请填写购方电话')
        return
      }
      if (!this.applyData.buyer_bank) {
        this.$message.error('请填写购方开户行')
        return
      }
      if (!this.applyData.buyer_bank_num) {
        this.$message.error('请填写购方银行账号')
        return
      }
      if (!this.applyData.invoice_cate) {
        this.$message.error('请填写货物或应税劳务、服务名称')
        return
      }
      if (!this.applyData.invoice_amount) {
        this.$message.error('请填写开票金额')
        return
      }
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.formData = new FormData()
          this.licenseList.forEach(file => this.formData.append('file[]', file.raw))
          for (let key in this.applyData) {
            this.formData.append(key, this.applyData[key])
          }
          this.$axios.post('/api/invoice_info', this.formData)
            .then((res) => {
              let { data } = res
              if (data.code === 0) {
                this.clearApplyDatas()
                this.formData = null
                this.licenseList = []
                this.$router.replace({path: '/invoice_info'})
              }
            })
        }
      })
    },
    clearApplyDatas () {
      this.applyData.invoice_mode = 1
      this.applyData.invoice_type = null
      this.applyData.is_tax_inclusive = null
      this.applyData.company_id = null
      this.applyData.company_name = ''
      this.applyData.invoice_cate = ''
      this.applyData.invoice_amount = null
      this.applyData.invoice_tax = ''
      this.applyData.operate_address = ''
      this.applyData.legaler_contact = ''
      this.applyData.invoice_payee = '' // 收款人
      this.applyData.invoice_reviewer = '' // 复核人
      this.applyData.invoice_drawer = '' // 开票人
      this.applyData.bank_id = '' // 销方银行信息
      this.applyData.buyer_tax_num = '' // 发票税号
      this.applyData.buyer_address = '' // 地址
      this.applyData.buyer_phone = '' // 电话
      this.applyData.buyer_bank = '' // 开户行
      this.applyData.buyer_bank_num = '' // 银行账号
      this.applyData.invoice_detail = '' // 发票明细
      this.applyData.invoice_remark = '' // 申请备注
      this.applyData.tax_plate_num = '' // 税盘编号
      this.applyData.file_location = '' // 档案位置
      this.applyData.exec_id = null
    }
  },
  mounted () {
    this.getInvoicePubData()
  }
}
</script>

<style lang="stylus" scoped>
@import '~styles/varibles.styl'
@import '~styles/vertical.styl'
[v-cloak]
  display: none
.bill
  marginLeft()
  .hide-style
    display: inherit
    overflow: hidden
    text-overflow: ellipsis
    white-space: nowrap
  .text-left
    text-align: left
  .mt-10
    margin-top: .2rem
  .pdtb5
    padding-top: .1rem
    padding-bottom: .1rem
  .invoiceBox
    border: 1px solid #e9e9e9
    width: 100%
    padding: .2rem
    margin-top: .2rem
  .cBorder_top
    border-top: 2px solid #9e5309
  .cBorder_1
    height: 184.34px
    padding-top: 30px
  .cBorder_1, .cBorder_2
    border-right: 2px solid #9e5309
    border-bottom: 2px solid #9e5309
    text-align: center
    display: table-cell
    vertical-align: middle
    line-height: 2
  .cInputB >>> .el-input__inner
    border: none !important
    padding: 0 0 2px 0 !important
    font-size: .28rem
    color: #333
  .bill-bottom >>> .el-input__inner
    border: none !important
    padding: 0 0 2px 0 !important
    font-size: .28rem
    color: #333
  .cBorder_3
    text-align: center
  .cBorder_5
    border-left: 2px solid #9e5309
    border-top: 2px solid #9e5309
  .cBorder_4, .cBorder_5
    border-right: 2px solid #9e5309
    padding: 5px
    text-align: center
    display: table-cell
    vertical-align: middle
  .errr
    color: red
  .cInputB
    border-bottom: 1px solid #e9e9e9!important
  .cBorder_6
    border-top: 2px solid #9e5309
    border-right: 2px solid #9e5309
  .cBorder_7
    border-bottom: 1px solid #e9e9e9
  .cBorder_6, .cBorder_7
    padding: 5px
    text-align: center
    display: table-cell
    vertical-align: middle
  .cBorder_8
    border-top: 2px solid #9e5309
    padding: 5px
    text-align: center
    display: table-cell
    vertical-align: middle
  .cBorder_3_left
    border-left: 2px solid #9e5309
</style>



// WEBPACK FOOTER //
// src/pages/invoicing/Bill.vue